import { render, staticRenderFns } from "./work.vue?vue&type=template&id=e02ce5a2"
import script from "./work.vue?vue&type=script&lang=js"
export * from "./work.vue?vue&type=script&lang=js"
import style0 from "./work.vue?vue&type=style&index=0&id=e02ce5a2&prod&lange=less&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports